
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Thêm nó vào màn hình chính của bạn để có trải nghiệm phong phú hơn và truy cập dễ dàng hơn.`,
's224cbcec014ef6b5': `Nhấp vào nút "Chia sẻ" trên thanh điều hướng`,
's37a9e8aec5713460': `Thêm`,
's386eca8362ff6155': `Nhấn Thêm nếu không có biểu tượng Chia sẻ`,
's4e1e10a6ca408245': `Nhấn vào "Thêm vào Màn hình chính"`,
's6196153c4b0c1ea0': `Cài đặt`,
's633502f7cff4f847': `Mở menu trình duyệt của bạn`,
's681e399d63311fba': `Hiển thị thư viện`,
's7f0591f08e318eda': `Nhấn Thêm trong menu Chia sẻ`,
's8114bd55cae5a22b': `Nhấp vào "Thêm vào Dock"`,
's922329d6f6213590': `Thêm vào Dock`,
's9af56bf005b49c74': `Kéo đến mục "Thêm vào Màn hình chính"`,
'sa5ef80b4bb9b39f8': `Thu gọn`,
'sba52286c21552a4e': `Cài đặt trên thiết bị của bạn để có trải nghiệm phong phú hơn và truy cập dễ dàng.`,
'sc16e00a7a8b2fde2': `Quay lại`,
'scdaf4bbff76674c8': `Thêm vào màn hình chính`,
'se0e473adfda8066c': `Mở trình duyệt chính của bạn`,
'se740f75b95a51807': `Thêm nó vào Dock của bạn để có trải nghiệm toàn diện hơn và truy cập dễ dàng hơn.`,
'sfea652f6580ff086': `Trang web này có cả chức năng đặc trưng ứng dụng.`,
    };
  